import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import LabeledOption from '../react-labeled-option';

import getIcon from './icons';

import './index.scss';

function TicketTypeSection({features, onChange}) {
  const optionsMap = features.map(({key, id, selected, label, disabled = false}) => (
    <LabeledOption
      disabled={disabled}
      icon={getIcon(key)}
      typeOfInput="Checkbox"
      key={key}
      id={(label && label.props && label.props.id) || key}
      onClick={(event) => {
        onChange(event, {id, key, label, selected: !selected});
      }}
      selected={selected}
      label={label}
    />
  ));

  return (
    <section className="ListingsFilter__sectionContainer">
      <h3 className="ListingsFilter__sectionContainer__Header">
        <FormattedMessage defaultMessage="Ticket Type" id="ListingsFilter.ticketTypeHeader" />
      </h3>
      {optionsMap}
    </section>
  );
}

TicketTypeSection.propTypes = {
  features: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
};

export default TicketTypeSection;
